var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-content"},[_c('el-container',[_c('el-header',[_c('Header')],1),_c('el-main',[_c('Main')],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }